export default "/images/e997a33df2a06e78d3efd092e613dbc3.avif";